// extracted by mini-css-extract-plugin
export var parcelRow = "_t5-0";